export enum CdtStatus {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  PUBLISH_IN_PROGRESS = 'PUBLISH_IN_PROGRESS',
  PUBLISH_FAILED = 'PUBLISH_FAILED',
  SUCCEEDED = 'SUCCEEDED',
  RUNNING = 'RUNNING',
  UNKNOWN = 'UNKNOWN'
}
